import { watch } from 'vue';

import useWebsocketChannel from '@/composables/useWebsocketChannel';
import { useTenantsStore } from '@/stores/tenants';
import { TWSMessagePayload } from '@/websocket/types';
import { EProcessImportStatus } from '@/constants';
import { downloadFile } from '@/utils';
import { showErrorNotification } from '@/domains/showErrorNotification';
import tt from '@/i18n/utils/translateText';
import useGlobalEventBus from '@/composables/useGlobalEventBus';

const useExportWsUtils = () => {
  const tenantsStore = useTenantsStore();

  const { emit: emitToBus } = useGlobalEventBus();

  const onMessage = (message: TWSMessagePayload) => {
    const { payload } = message;

    const canDownloadFile = payload.status === EProcessImportStatus.success && payload.url && payload.filename;

    if (canDownloadFile) {
      downloadFile(payload.url as string, payload.filename as string);
    }

    if (payload.status === EProcessImportStatus.failed) {
      showErrorNotification({ message: tt('shared.error.exportFileError') });
    }

    emitToBus('exportFinished', payload.exportId as string);
  };

  const { connect, closeConnection } = useWebsocketChannel({
    channelName: 'ExportsChannel',
    onMessage,
  });

  const connectToExportsChannel = () => {
    connect();
  };

  const disconnectFromExportsChannel = () => {
    closeConnection();
  };

  const reconnectExportsChannel = () => {
    disconnectFromExportsChannel();
    connectToExportsChannel();
  };

  watch(() => tenantsStore.currentTenant?.id, () => {
    if (!tenantsStore.currentTenant?.id) return;
    reconnectExportsChannel();
  });
};

export default useExportWsUtils;
